import { render, staticRenderFns } from "./MainNotifications.vue?vue&type=template&id=5eaa7bfd&scoped=true"
import script from "./MainNotifications.vue?vue&type=script&lang=js"
export * from "./MainNotifications.vue?vue&type=script&lang=js"
import style0 from "./MainNotifications.vue?vue&type=style&index=0&id=5eaa7bfd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eaa7bfd",
  null
  
)

export default component.exports